<template>
    <div>
        <h1>{{ $t("admin.adminPolicyList.header") }}</h1>
        <router-link to="/admin/policyCreate">{{ $t("admin.adminPolicyList.link.create") }}</router-link><br/>
        <form id="search" @submit="policySearch">
            <label for="searchTerm">{{ $t("admin.adminPolicyList.search") }}: </label>
            <input id="searchTerm" name="searchTerm" v-model="searchTerm"><br/>

            <input type="submit" class="submit" v-bind:value="$t('admin.adminPolicyList.button.search')">
        </form>

        <table v-if="policyList" class="datatable">
            <caption class="caption">Policy list table</caption>
            <tr>
                <th scope="col">{{ $t("admin.adminPolicyList.table.policyName") }}</th>
                <th scope="col">{{ $t("admin.adminPolicyList.table.policyDescription") }}</th>
            </tr>
            <tr v-for="(policy, index) in policyList" v-bind:key="index">
                <td><router-link :to="'/admin/policyView/' + policy.policyId">{{ policy.policyName }}</router-link></td>
                <td>{{ policy.policyDescription }}</td>
            </tr>
        </table>
    </div>
</template>

<script>
    import { adminService } from '@/services/admin.service'

    export default {
        name: 'AdminPolicyList',
        data: function() {
            return { policyList: [], searchTerm: "" };
        },
        created: function() {
            this.policySearch(null);
        },
        methods: {
            policySearch: function (event) {
                adminService.policySearch(this.searchTerm).then((data) => {
                    this.policyList.splice(0, this.policyList.length)
                    for(let d of data){
                        if(d){
                            d.policyDescription = decodeURIComponent(atob(d.policyDescription))
                        }
                        this.policyList.push(d)
                    }
                }).catch((err) => {
                    console.error('Unable to get policy: ', err)
                })
                if (event) {
                    event.preventDefault()
                }
            }
        }
    }
</script>
